import type { MenuItemWithId } from './menu';

export function separateMenuGroups(
  groups: MenuItemWithId[][],
): MenuItemWithId[] {
  const nonEmptyGroups = groups.filter((items) => items.length > 0);

  return nonEmptyGroups.flatMap((items, index) => {
    if (index === 0) {
      return items;
    }
    const result: MenuItemWithId[] = [
      { isSeparator: true, id: `separator-${index + 1}` },
      ...items,
    ];
    return result;
  });
}
